export default {
  async loadSections (context, term) {
    let query = { active: true, term, $limit: 30, $sort: { order: 1 } }
    let { data, total } = await this.$feathers.service('orientation/section').find({ query })
    context.commit('setSectionCount', total)
    if (total > data.length) {
      // Load another chunk until we have loaded all of them
      query.$skip = 30
      let { data: moreData } = await this.$feathers.service('orientation/section').find({ query })
      for (let i = 0; i < moreData.length; i++) {
        data.push(moreData[i])
      }
    }
    context.commit('setSections', data)
    let slides = 0
    for (const { slideCount } of data) slides += slideCount
    context.commit('setSlideCount', slides)
  },
  buildStudentQuery (context) {
    let query = { term: context.state.term, $sort: { last: 1, preferred: 1 } }
    // Load any stored filters and add them to the query
    let { name, sections, sectionStatus, sectionsCompleted, slidesCompleted, lastUpdate, excludeTests } = context.state.filters
    // Check to see if we are filtering by name
    if (name !== '' && name != null) {
      if (name.search(',') > 0) {
        let [last, first] = name.split(',')
        query.last = { $regex: last.trim(' '), $options: 'i' }
        query.preferred = { $regex: first.trim(' '), $options: 'i' }
      } else if (name.search(' ') > 0) {
        let [first, last] = name.split(' ')
        query.preferred = { $regex: first.trim(' '), $options: 'i' }
        query.last = { $regex: last.trim(' '), $options: 'i' }
      } else {
        query.$or = [
          { preferred: { $regex: name.trim(' '), $options: 'i' } },
          { last: { $regex: name.trim(' '), $options: 'i' } }
        ]
      }
    }
    // Check to see if we are filtering by section (with a section status which defaults to Complete)
    if (sections.length > 0) {
      if (sectionStatus.length === 0) sectionStatus.push('Complete')
      let $or = false
      if (sections.length === 1 && sections[0] === 'you\'re-a-scot') {
        sectionStatus.forEach((val) => { $or = $or || val === 'Locked' })
      }
      if ($or) {
        query.$or = [
          { sections: { $not: { $elemMatch: { section: 'you\'re-a-scot' } } } },
          { sections: { $elemMatch: { section: { $in: sections }, status: { $in: sectionStatus } } } }
        ]
      } else {
        query.sections = { $elemMatch: { section: { $in: sections }, status: { $in: sectionStatus } } }
      }
    }
    // Check to see if we are filtering by section percent complete (which should be an object with min and max values; same logic as slide percent and lastUpdate below)
    if (sectionsCompleted.min != null || sectionsCompleted.max != null) {
      query['done.sections'] = { }
      if (sectionsCompleted.min != null) query['done.sections'].$gte = sectionsCompleted.min
      if (sectionsCompleted.max != null) query['done.sections'].$lte = sectionsCompleted.max
    }
    // Check to see if we are filtering by slide percent complete (which should be an object with min and max values; same logic as section percent above and lastUpdate below)
    if (slidesCompleted.min != null || slidesCompleted.max != null) {
      query['done.slides'] = { }
      if (slidesCompleted.min != null) query['done.slides'].$gte = slidesCompleted.min
      if (slidesCompleted.max != null) query['done.slides'].$lte = slidesCompleted.max
    }
    // Check to see if we are filtering by last updated date (which should be an object with min and max values; same logic as section percent and slide percent above)
    if (lastUpdate.min != null || lastUpdate.max != null) {
      query.lastUpdatedAt = {}
      if (lastUpdate.min != null) query.lastUpdatedAt.$gte = lastUpdate.min
      if (lastUpdate.max != null) query.lastUpdatedAt.$lte = lastUpdate.max
    }
    if (excludeTests) {
      query.isTest = false
    } else {
      query.isTest = true
    }
    return query
  },
  async loadStudents (context) {
    let query = await context.dispatch('buildStudentQuery')

    // Add the pagination values to the query
    let { page, itemsPerPage, sort, desc } = context.state.pagination
    // Limit to the number of items that the user has set
    query.$limit = itemsPerPage
    // If we are not on page 1, then skip however many would have been on the prior pages
    if (page > 1) { query.$skip = itemsPerPage * (page - 1) }
    // If they have a custom sort order, then sort by that
    if (sort && sort.length > 0) {
      query.$sort = {}
      for (let i = 0; i < sort.length; i++) {
        query.$sort[sort[i]] = desc[i] ? 1 : -1
      }
    }
    const sectionHash = {}
    for (let i = 0; i < context.state.sections.length; i++) {
      sectionHash[context.state.sections[i].code] = context.state.sections[i].slideCount
    }
    this.$feathers.service('orientation/tracker').find({ query }).then(({ total, data }) => {
      context.commit('setStudentCount', total)
      let arr = []
      for (let i = 0; i < data.length; i++) {
        let temp = { ...data[i] }
        temp.done = { sections: 0, slides: 0 }
        // Turn the array of checklist items into a hashed index with the section code as the key
        if ('sections' in data[i] && data[i].sections != null) {
          for (let j = 0; j < data[i].sections.length; j++) {
            let { section, status, lastSlide, highSlide } = data[i].sections[j]
            temp[section] = { status, lastSlide, highSlide }
            if (status === 'Complete') {
              temp.done.sections++
              temp.done.slides += highSlide
            } else if (highSlide > 1) {
              temp.done.slides += (highSlide - 1)
            }
          }
        }
        arr.push(temp)
      }
      context.commit('setStudents', arr)
    })
  },
  updateStudent (context, { index, data }) {
    data.done = { sections: 0, slides: 0 }
    // Turn the array of checklist items into a hashed index with the section code as the key
    for (let j = 0; j < data.checklist.length; j++) {
      let { section, status, slides, lastSlide, highSlide } = data.checklist[j]
      data[section] = { status, slides, lastSlide, highSlide }
      if (status === 'Complete') {
        data.done.sections++
        data.done.slides += highSlide
      } else if (highSlide > 1) {
        data.done.slides += (highSlide - 1)
      }
    }
    context.commit('updateStudent', { index, data })
  }
}
